// FutureLab
import SessionFeedback from '../components/feedback/SessionFeedback';

export function NewSessionPage() {
	return (
		<div className="mx-auto w-full md:w-7/8 lg:w-2/3 xl:w-1/2">
			<SessionFeedback />
		</div>
	);
}
